





















import { Component, Vue, Prop, Provide, Watch } from 'vue-property-decorator'
import SingleRowSelect from '@/components/common/singleRowSelect/SingleRowSelect.vue'
import filterData from '@/apps/index/components/data'
import { getInitInfo, bookSeries } from './../model/api'

@Component({
  components: { SingleRowSelect }
})
export default class TopFilter extends Vue {
  @Prop() site!: any
  public filterList = filterData
  private get subjectId() {
    return this.$store.state.subject.value
  }

  private showRowItem(item) {
    if (this.bookorkps == 1) {
      if (['grade', 'textbookVersion', 'paperType'].includes(item.label)) {
        return false
      }
    }
    return true
  }

  private get bookorkps() {
    return this.$store.state.question.bookorkps
  }

  // mounted
  public mounted() {
    this.getFilters()
  }
  @Watch('subjectId')
  onSubjectIdChange(val) {
    this.getFilters()
  }

  /**
   * getChoose
   */
  // methods
  public getChoose(val: any) {
    switch (val.group) {
      case '题型：':
        this.$store.commit('SET_QUESTIONTYPE', val.value)
        this.$store.commit('SET_QUESTIONTYPENAME', val.name)
        break
      case '地区：':
        this.$store.commit('SET_REGION', val.value)
        this.$store.commit('SET_PROVINCENAME', val.name)
        break
      case '年份：':
        this.$store.commit('SET_YEAR', val.value)
        break
      case '难度：':
        this.$store.commit('SET_DIFF', val.value)
        this.$store.commit('SET_DIFFNAME', val.name)
        break
      case '年级：':
        this.$store.commit('SET_GRADE', val.value)
        break
      case '教材版本：':
        this.$store.commit('SET_TEXTBOOK_VERSION', val.value)
        break
      case '试卷类型：':
        this.$store.commit('SET_PAPER_TYPE', val.value)
        break
      default:
        break
    }
  }
  /**
   * getFilters
   */
  public async getFilters() {
    let types: any = {
      name: '题型：',
      label: 'question',
      val: []
    }
    let sections: any = {
      name: '地区：',
      label: 'section',
      val: [{ name: '全部', val: 0 }]
    }
    let years: any = {
      name: '年份：',
      label: 'year',
      val: []
    }

    // 年级+term
    let grade_term_choices: any = {
      name: '年级：',
      label: 'grade',
      val: []
    }

    let books: any = {
      name: '教材版本：',
      label: 'textbookVersion',
      val: [{ name: '全部', val: '' }]
    }

    let paperTypes: any = {
      name: '试卷类型：',
      label: 'paperType',
      val: []
    }
    //

    let difficulty: any = {
      name: '难度：',
      label: 'difficulty',
      val: []
    }
    let [{ data }, bookSeriesRet] = await Promise.all([
      getInitInfo({
        subject_id: this.subjectId
      }),
      bookSeries({
        subject_id: this.subjectId
      })
    ])
    for (let n of data.difficulty_choices) {
      difficulty.val = [...difficulty.val, { name: n[1], val: n[0] }]
    }
    for (let n of data.question_type_choices) {
      types.val = [...types.val, { name: n[1], val: n[0] }]
    }
    for (let n of data.year_choices) {
      years.val = [...years.val, { name: n[1], val: n[0] }]
    }
    for (let n of data.region_choices) {
      sections.val = [...sections.val, { name: n[1], val: n[0] }]
    }
    for (let item of data.all_paper_type_choices || []) {
      paperTypes.val = [...paperTypes.val, { name: item[1], val: item[0] }]
    }

    for (let item of bookSeriesRet.data || []) {
      books.val = [...books.val, { name: item.name, val: item._id }]
    }
    for (let item of data.grade_term_choices || []) {
      grade_term_choices.val = [...grade_term_choices.val, { name: item[1], val: item[0] }]
    }
    this.filterList = [types, difficulty, years, grade_term_choices, books, paperTypes, sections]
    if (data.default_book && data.default_book.length > 0) {
      this.$store.commit('SET_DEFAULTBOOK', data.default_book)
    }
  }
}
